/**
 * URLs officielles des prop firms du comparateur — à remplacer par les liens affiliés.
 *
 * Clé = slug de la firme tel qu'utilisé dans les données du comparateur
 * (ComparatorFirm.slug / colonne firm_slug du CSV).
 *
 * Résolution du bouton « Démarrer le challenge » (voir lib/affiliate.ts) :
 * offer.affiliateUrl → firm.affiliateUrl (BDD, avec UTM) → cette config (sans UTM).
 * Quand un vrai lien affilié est saisi en admin, il prend automatiquement le dessus.
 */
export const PROP_FIRM_OFFICIAL_URLS: Record<string, string> = {
  "lucid-trading": "https://lucidtrading.com/",
  "my-funded-futures": "https://myfundedfutures.com/",
  tradeify: "https://tradeify.co/",
  "funded-futures-network": "https://fundedfuturesnetwork.com/",
  "take-profit-trader": "https://takeprofittrader.com/",
  "funded-next-futures": "https://fundednext.com/futures",
  daytraders: "https://daytraders.com/",
  "legends-trading": "https://thelegendstrading.com/",
  "aqua-futures": "https://www.aquafutures.io/",
  "yrm-prop": "https://yrmprop.com/",
  blusky: "https://blusky.pro/",
  tradeday: "https://www.tradeday.com/",
  "elite-trader-funding": "https://elitetraderfunding.com/",
  "taurus-arena": "https://taurusarena.com/",
  phidias: "https://phidiaspropfirm.com/",
  topstep: "https://www.topstep.com/",
  "alpha-futures": "https://alpha-futures.com/",
  futureselite: "https://futureselite.com/",
  "apex-trader-funding": "https://apextraderfunding.com/",
  bulenox: "https://bulenox.com/",
};

/** URL officielle d'une firme par slug, ou null si absente de la config. */
export function officialUrlForSlug(slug: string): string | null {
  return PROP_FIRM_OFFICIAL_URLS[slug] ?? null;
}
